"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.827 3.726a.5.5 0 0 1 .5-.5h11.37a.5.5 0 0 1 .5.5v6.701a.5.5 0 0 1-.5.5H2.326a.5.5 0 0 1-.5-.5v-6.7Zm.5 8.201h11.37c.826 0 1.5-.673 1.5-1.5v-6.7c0-.828-.674-1.5-1.5-1.5H2.326c-.827 0-1.5.672-1.5 1.5v6.7c0 .827.673 1.5 1.5 1.5Zm5.685-6.633a.57.57 0 1 0 0-1.139.57.57 0 0 0 0 1.139ZM16 13.774H0v-1h16v1Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.553 4.84c0-.104.084-.188.188-.188h18.554c.103 0 .188.084.188.187v11.552a.188.188 0 0 1-.188.187H2.741a.188.188 0 0 1-.188-.187V4.839Zm.188 12.863h18.554c.724 0 1.313-.588 1.313-1.312V4.839c0-.723-.59-1.312-1.313-1.312H2.741c-.724 0-1.313.589-1.313 1.312v11.552c0 .724.59 1.312 1.313 1.312Zm9.277-9.762a.854.854 0 1 0 0-1.708.854.854 0 0 0 0 1.708ZM24 20.473H0v-1.125h24v1.125Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.404 6.453a.25.25 0 0 1 .25-.25h24.74a.25.25 0 0 1 .25.25v15.402a.25.25 0 0 1-.25.25H3.653a.25.25 0 0 1-.25-.25V6.453Zm.25 17.152h24.74c.964 0 1.75-.785 1.75-1.75V6.453c0-.965-.786-1.75-1.75-1.75H3.653c-.965 0-1.75.785-1.75 1.75v15.402c0 .965.785 1.75 1.75 1.75Zm12.37-13.017a1.14 1.14 0 1 0 0-2.278 1.14 1.14 0 0 0 0 2.278ZM32 27.297H0v-1.5h32v1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.92 33.345h38.232V9.116H4.919v24.229Zm-.188 1.874H43.34a1.69 1.69 0 0 0 1.687-1.687V8.929a1.69 1.69 0 0 0-1.688-1.688H4.733A1.69 1.69 0 0 0 3.044 8.93v24.603c0 .93.758 1.687 1.688 1.687Zm19.304-22.752a1.708 1.708 0 1 0 0 3.415 1.708 1.708 0 0 0 0-3.415ZM48 40.759H0v-1.875h48v1.875Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.559 44.46h50.977V12.155H6.559V44.46Zm-.25 2.499h51.477a2.252 2.252 0 0 0 2.25-2.25V11.905a2.252 2.252 0 0 0-2.25-2.25H6.309a2.253 2.253 0 0 0-2.25 2.25v32.804c0 1.241 1.01 2.25 2.25 2.25Zm25.739-30.337a2.277 2.277 0 1 0 0 4.554 2.277 2.277 0 0 0 0-4.554ZM64 54.345H0v-2.5h64v2.5Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconLaptop = function IconLaptop(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Laptop' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Laptop"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconLaptop.sizes = [16, 24, 32, 48, 64];
IconLaptop.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconLaptop;
exports.default = _default;